import { GhostStallPayload, LatLon } from '../domain/types.ts';
import { GAME_CONFIG } from '../config/gameConfig.ts';
import { getApiUrl } from '../config/apiConfig.ts';

export class GhostClient {
  private static FAKE_GHOSTS: GhostStallPayload[] = [
    {
      uid: 'u-rival-minh',
      sid: 's-rival-1',
      cell: 'cell:100:-50',
      x: 75,
      y: -65,
      name: 'Trà Chanh Chém Gió',
      level: 3,
      chairs: 10,
      price: 20_000,
      rep: 78,
      activeAt: Date.now() - 3600_000,
    },
    {
      uid: 'u-rival-lan',
      sid: 's-rival-2',
      cell: 'cell:-120:80',
      x: -110,
      y: 85,
      name: 'Nước Mía Siêu Sạch Cô Lan',
      level: 2,
      chairs: 6,
      price: 15_000,
      rep: 65,
      activeAt: Date.now() - 7200_000,
    },
  ];

  public static async queryNearbyGhosts(
    _center: LatLon,
    _worldRadiusM = 500
  ): Promise<GhostStallPayload[]> {
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);

      const res = await fetch(getApiUrl('/api/stalls/nearby'), {
        signal: controller.signal,
      }).catch(() => null);

      clearTimeout(timer);

      if (res && res.ok) {
        const data = (await res.json()) as GhostStallPayload[];
        if (Array.isArray(data) && data.length > 0) {
          return data;
        }
      }
    } catch {
      // Fallback
    }

    // Luôn có ghost rivals mẫu để người chơi trải nghiệm ngay
    return this.FAKE_GHOSTS;
  }

  public static async registerStall(payload: Partial<GhostStallPayload>): Promise<boolean> {
    try {
      const res = await fetch(getApiUrl('/api/stalls/register'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).catch(() => null);

      return !!(res && res.ok);
    } catch {
      return false;
    }
  }

  public static isStale(activeAt: number): boolean {
    return Date.now() - activeAt > GAME_CONFIG.ghost.staleThresholdMs;
  }
}
